(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fp-footer"] && !Shopify.designMode) return;
  try {
    
/* Klappt die Footer-Spalten unter 750px zu - bis auf die erste. Ohne dieses
   Skript bleibt alles offen, weil das Markup "open" mitbringt. Das ist der
   gewollte Rueckfall: lieber alles sichtbar als nichts. */
(function () {
  var eng = window.matchMedia('(max-width: 749px)');
  function sync() {
    var cols = document.querySelectorAll('.fp-ft__col');
    for (var i = 0; i < cols.length; i++) {
      cols[i].open = eng.matches ? i === 0 : true;
    }
  }
  sync();
  if (eng.addEventListener) { eng.addEventListener('change', sync); }
  else if (eng.addListener) { eng.addListener(sync); }
  document.addEventListener('shopify:section:load', sync);
})();

  } catch(e) { console.error(e); }
})();
})();
